import React from 'react'
import styled from '@emotion/styled'
import { Col, Form, Input, Row } from 'antd'
import ProjectUsers from 'views/UserManagement/Projects/components/EditableUsers/ProjectUsers'

const StyledProjectForm = styled.div({})

const ProjectForm = ({ project, form, formKeys }) => {
  const { getFieldDecorator } = form
  return (
    <StyledProjectForm>
      <Form layout="vertical" hideRequiredMark>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="Project Name">
              {getFieldDecorator(formKeys.NAME, {
                initialValue: project?.name,
                rules: [{ required: true, whitespace: true, message: 'Please enter project name' }]
              })(<Input placeholder="enter project name" />)}
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="Users">
              <ProjectUsers users={project?.users} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </StyledProjectForm>
  )
}

export default ProjectForm
